export default {
  trigger: 'Kutsu ravintolan omistaja',
  title: 'Kutsu ravintolan omistaja',
  description:
    'Luo tili ravintolan omistajalle. Hän saa sähköpostin, jossa on väliaikainen salasana kirjautumista ja käyttöönoton viimeistelyä varten.',
  fields: {
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    email: 'Sähköposti',
  },
  buttons: {
    invite: 'Lähetä kutsu',
    cancel: 'Peruuta',
  },
  toasts: {
    invited: '{{email}} on kutsuttu viimeistelemään käyttöönotto.',
    failed: 'Omistajan tilin luominen epäonnistui. Yritä uudelleen.',
  },
};
